import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { isTranslated } from '../../../../utils/ugc/isTranslated';
import TranslatedBadge from '../../../shared/TranslatedBadge';

import './style.scss';

const xss = require('xss');

export const replaceBreakTags = (string, replacer = '\r\n') =>
    string.replace(/\s?(<br\s?\/?>)\s?/g, replacer);

class Description extends Component {

    constructor() {
        super();

        this.state = {
            descExpanded: false
        };

        this.onReadMoreClick = this.onReadMoreClick.bind(this);
    }

    onReadMoreClick() {
        this.setState({
            descExpanded: !this.state.descExpanded
        });
    }

    render() {
        const { descExpanded } = this.state;
        const { showTranslatedBadge, userDescription } = this.props;
        let desc = '';

        try {
            desc = xss(replaceBreakTags(userDescription), {
                whiteList: [],
                stripIgnoreTag: true,
                stripIgnoreTagBody: ['script', 'a']
            });
        } catch (error) {
            // fail silently
        }

        if (!desc.length) {
            return null;
        }

        const showReadMore = desc.length > 120;
        const descClassName = classNames('seller-desc', {
            'expanded': descExpanded || !showReadMore
        });

        return (
            <article className={descClassName}>
                <div className="inner">{desc}</div>
                {showReadMore &&
                    <button className="read-more" onClick={this.onReadMoreClick}>
                        <I18n k={`gig_page_perseus.seller_card.read_more_text.${descExpanded ? 'less' : 'more'}`}/>
                    </button>
                }
                {showTranslatedBadge && <TranslatedBadge/>}
            </article>
        );
    }
}

Description.propTypes = {
    userDescription: PropTypes.string,
    showTranslatedBadge: PropTypes.bool
};

const mapStateToProps = ({ ugc }) => ({
    showTranslatedBadge: isTranslated(ugc)
});

const ConnectedDescription = connect(mapStateToProps)(Description);

export { Description, ConnectedDescription };

export default ConnectedDescription;
